import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
import ServiceCTA from '../../components/ServiceCTA';
import RelatedServices from '../../components/RelatedServices';
import { Link } from 'react-router-dom';

const MarketingService = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center fade-in">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
              マーケティングサポート
            </h1>
            <p className="text-xl text-gray-700">
              Googleマップ最適化（MEO）で、地域のお客様に見つけてもらいやすくします。
            </p>
          </div>
        </div>
      </section>

      {/* Main Content - 2 Column Layout */}
      <section className="section-spacing bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left Column */}
              <div className="lg:col-span-2 space-y-8">
                <div className="rounded-2xl overflow-hidden shadow-md">
                  <img 
                    src="https://images.unsplash.com/photo-1548345680-f5475ea5df84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtYXAlMjBsb2NhdGlvbnxlbnwwfHx8fDE3NjQ2NDk0ODV8MA&ixlib=rb-4.1.0&q=85"
                    alt="マーケティングサポート"
                    className="w-full h-auto object-cover"
                  />
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    こんなことでお困りではありませんか？
                  </h2>
                  <ul className="space-y-3">
                    {[
                      'Googleマップでお店が見つからない',
                      '地域で検索されても上位に表示されない',
                      '口コミが少なくて信頼感が伝わらない',
                      '新規のお客様が入ってこない',
                      'MEO対策って何をしたらいいかわからない'
                    ].map((problem, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{problem}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    サービス内容
                  </h2>
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        Googleマップ最適化（MEO）
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        「上郡町 飲食店」「赤穂 美容院」など、地域名と業種で検索されたときに、上位表示されるように最適化します。店舗情報の整備、キーワード設定、写真の追加などを行います。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        口コミ促進サポート
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        Googleマップの口コミは、新規客の来店に大きく影響します。お客様に口コミを書いていただくためのサポートや、口コミへの返信方法などをアドバイスいたします。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        Google投稿・情報更新
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        定期的にGoogleマイビジネスに投稿することで、お店の活性をアピール。キャンペーン情報や新メニューのお知らせ、営業時間の変更などをタイムリーに発信します。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスでできること
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '地域検索で上位表示され、見つけてもらいやすくなる',
                      '来店意欲の高いお客様を集客できる',
                      '口コミが増えて信頼性が向上する',
                      '競合店に負けない存在感を示せる',
                      '無料で始められるのでコストパフォーマンスが高い'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスが向いている方
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '地域密着で営業している飲食店やサロン',
                      '新規開店で認知度を上げたい方',
                      'Googleマップで見つけてもらいたい方',
                      '競合店に負けないようにしたい方',
                      'コストをかけずに集客したい小規模店舗'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <Sparkles className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Right Column - Sidebar */}
              <div className="lg:col-span-1 space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-md border-2" style={{ borderColor: '#F7C9D3' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    料金の目安
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">初期設定</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>15,000円～</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">月額サポート</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>10,000円～/月</p>
                      <p className="text-xs text-gray-500 mt-1">（希望者のみ）</p>
                    </div>
                    <Link to="/pricing" className="block text-center text-sm text-[#F7C9D3] hover:text-[#2C2C2C] font-medium mt-4">
                      詳しい料金を見る →
                    </Link>
                  </div>
                </div>

                <div className="rounded-2xl p-6 shadow-sm" style={{ backgroundColor: '#FFF7FA' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    このサービスのポイント
                  </h3>
                  <ul className="space-y-3">
                    {[
                      '地域検索で上位表示を目指す',
                      '口コミ対応もサポート',
                      '無料で始められて効果が高い'
                    ].map((point, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-2 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-sm text-gray-700">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                  <p className="text-sm text-gray-600 mb-4">
                    このサービスについてもっと詳しく知りたい方
                  </p>
                  <Link to="/contact" className="btn-primary block py-3 rounded-full font-medium text-sm">
                    無料相談はこちら
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RelatedServices currentService="marketing" />
      <ServiceCTA />
    </div>
  );
};

export default MarketingService;